import type { TableSelectedCell } from '@/components/custom/arito/custom-input-table/hooks';
import { useTableRows } from '@/components/custom/arito/custom-input-table/hooks';

export type SelectedCellInfo = TableSelectedCell;

export default function useInputTableRows<
  T extends {
    uuid: string;
    line?: number;
  }
>(
  initialRows: T[] = [],
  onChange?: (rows: T[]) => void,
  onFieldValueChange?: (row: T, field: string, value: any) => Partial<T>
) {
  const handleFieldValueChange = (row: T, field: string, value: any): Partial<T> => {
    const externalUpdates = onFieldValueChange?.(row, field, value) || {};

    return {
      ...externalUpdates
    };
  };

  const {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handleMoveRow,
    handlePasteRow,
    setNonWritableFields,
    setPasteConfigs
  } = useTableRows<T>({
    initialRows,
    onChange,
    onFieldValueChange: handleFieldValueChange
  });

  return {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs
  };
}
